import { useTranslation } from 'react-i18next';
import { StyleSheet } from 'react-native';
import BodyBaseBoldText from 'shared/components/vxl/typography/primary/body/BodyBaseBoldText';
import BodyBaseText from 'shared/components/vxl/typography/primary/body/BodyBaseText';
import EmptyStateScreen from 'shared/patterns/vxl/EmptyStateScreen/EmptyStateScreen';

const EmptyRecipientList = () => {
  const { t: translatedText } = useTranslation('moveMoney', {
    keyPrefix: 'sender',
  });

  return (
    <EmptyStateScreen
      headlineText=""
      illustrationKey="FLASHLIGHT_A"
      content={
        <BodyBaseText style={styles.text}>
          {translatedText('recipients.noRecipientsFoundPrefix')}
          <BodyBaseBoldText>
            {translatedText('recipients.noRecipientsFoundEmailAddress')}
          </BodyBaseBoldText>
          {translatedText('recipients.noRecipientsFoundOr')}
          <BodyBaseBoldText>
            {translatedText('recipients.noRecipientsFoundPhoneNumber')}
          </BodyBaseBoldText>
        </BodyBaseText>
      }
    />
  );
};

const styles = StyleSheet.create({
  text: {
    textAlign: 'center',
  },
});

export default EmptyRecipientList;
